<div class="spinner-wrapper">
    <span></span>
</div>